import { Action } from '@reduxjs/toolkit';
import { Epic, combineEpics } from 'redux-observable';
import { filter, from, map, switchMap } from 'rxjs';

import { catchAndLogError } from 'utils/common';

import actions from './catalogs.actions';
import * as apis from './catalogs.api';

const { getAllShallow, getAllDeep } = actions;

/** Fetch shallow catalogs */
export const getShallowCatalogsEpic: Epic<Action, Action> = (action$) =>
  action$.pipe(
    filter(getAllShallow.pending.match),
    switchMap(() =>
      from(apis.allShallow()).pipe(
        map(getAllShallow.fulfilled),
        catchAndLogError(getAllShallow.rejected())
      )
    )
  );

/** Fetch deep catalogs */
export const getDeepCatalogsEpic: Epic<Action, Action> = (action$) =>
  action$.pipe(
    filter(getAllDeep.pending.match),
    switchMap(() =>
      from(apis.allDeep()).pipe(map(getAllDeep.fulfilled), catchAndLogError(getAllDeep.rejected()))
    )
  );

const combined = combineEpics(getShallowCatalogsEpic, getDeepCatalogsEpic);
export default combined;
